(function () {
  "use strict";

  // RAINBOWCAKES: 配送希望日（必須）が未選択のままではチェックアウトに進めないようにする
  // 対象アプリ: 配送＆注文サポーター（ネットイヤーグループ株式会社）が挿入するカート属性フィールド
  var DATE_FIELD_NAME = "attributes[配送希望日]";
  var INVALID_VALUES = ["希望なし", ""];
  var ERROR_TEXT = "配送希望日をご選択ください。";
  var ERROR_CLASS = "rc-delivery-date-error";
  var lastClickedCheckout = false;

  // フォールバック: event.submitter に対応していない環境向けに、クリックされたボタンを記録しておく
  document.addEventListener(
    "click",
    function (e) {
      var el = e.target && e.target.closest
        ? e.target.closest('button[name="checkout"], input[name="checkout"]')
        : null;
      if (el) lastClickedCheckout = true;
    },
    true
  );

  function findDateField(form) {
    if (!form) return null;
    var fields = form.querySelectorAll("input[name], select[name], textarea[name]");
    for (var i = 0; i < fields.length; i++) {
      if (fields[i].name === DATE_FIELD_NAME) return fields[i];
    }
    return null;
  }

  function isInvalid(field) {
    var v = (field.value || "").trim();
    return INVALID_VALUES.indexOf(v) !== -1;
  }

  function clearError(field) {
    try {
      var parent = field.parentNode;
      if (parent) {
        var existing = parent.querySelector("." + ERROR_CLASS);
        if (existing) existing.parentNode.removeChild(existing);
      }
      field.style.borderColor = "";
    } catch (err) {
      /* no-op: never let cleanup break the page */
    }
  }

  function showError(field) {
    try {
      clearError(field);
      var msg = document.createElement("div");
      msg.className = ERROR_CLASS;
      msg.textContent = ERROR_TEXT;
      msg.style.cssText = "color:#d02e2e;font-size:0.85em;margin-top:6px;";
      field.insertAdjacentElement("afterend", msg);
      field.style.borderColor = "#d02e2e";
      if (typeof field.scrollIntoView === "function") {
        field.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    } catch (err) {
      /* no-op */
    }
  }

  function handleSubmit(event) {
    try {
      var form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      var submitter = event.submitter;
      var isCheckout =
        (submitter && submitter.name === "checkout") || lastClickedCheckout;
      lastClickedCheckout = false;

      if (!isCheckout) return;

      var field = findDateField(form);
      // アプリの仕様変更等でフィールドが見つからない場合は、購入を止めない（フェイルオープン）
      if (!field) return;

      if (isInvalid(field)) {
        event.preventDefault();
        event.stopPropagation();
        showError(field);
      } else {
        clearError(field);
      }
    } catch (err) {
      // 予期しないエラー時も購入をブロックしない
      if (window.console && console.error) {
        console.error("[delivery-date-required]", err);
      }
    }
  }

  document.addEventListener("submit", handleSubmit, true);

  document.addEventListener(
    "change",
    function (event) {
      try {
        if (event.target && event.target.name === DATE_FIELD_NAME && !isInvalid(event.target)) {
          clearError(event.target);
        }
      } catch (err) {
        /* no-op */
      }
    },
    true
  );
})();
